<div class="body_content_wrapper position-relative">
    <section class="sd-section">
        <div class="container">
            <div class="sd-submit">
                <div class="contact-header" style="text-align: center; margin-bottom: 2rem;">
                    <h1 style="font-size: 2rem; font-weight: 800; color: #1e293b; margin-bottom: .5rem;">Contact Us</h1>
                    <p style="color: #64748b; font-size: 1.05rem; max-width: 500px; margin: 0 auto;">
                        Excited to partner with your business, offering top affiliate services for growth.
                    </p>
                </div>

                <div class="sd-card">
                    <form class="sd-form active" id="contact-page-form" style="padding: 2.5rem;" #contactForm="ngForm"
                        (ngSubmit)="submitContact(contactForm)" novalidate>
                        <div class="sd-row">
                            <div class="sd-field">
                                <label class="sd-label" for="contact-name">Full Name</label>
                                <input id="contact-name" name="fullName" type="text" class="sd-input" placeholder="Name"
                                    [(ngModel)]="contact.FullName" required>
                            </div>
                            <div class="sd-field">
                                <label class="sd-label" for="contact-email">Email</label>
                                <input id="contact-email" name="email" type="email" class="sd-input" placeholder="Email"
                                    pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}" required
                                    title="Please enter a valid email address (e.g. name@example.com)"
                                    [(ngModel)]="contact.Email">
                            </div>
                            <div class="sd-field">
                                <label class="sd-label" for="contact-number">Contact Number</label>
                                <input id="contact-number" name="phone" type="tel" class="sd-input"
                                    placeholder="+code xxxxxxxxxx" pattern="^\+?[0-9]*$" inputmode="tel" required
                                    title="Please enter numbers or a + sign only" [(ngModel)]="contact.ContactNumber">
                            </div>
                            <div class="sd-field">
                                <label class="sd-label" for="contact-subject">Subject</label>
                                <input id="contact-subject" name="subject" type="text" class="sd-input"
                                    placeholder="Subject" [(ngModel)]="contact.MailSubject" required>
                            </div>
                        </div>

                        <div class="sd-field">
                            <label class="sd-label" for="contact-message">Message</label>
                            <textarea id="contact-message" name="message" class="sd-textarea"
                                placeholder="e.g. I would like to discuss a potential partnership..."
                                style="min-height: 120px;" [(ngModel)]="contact.MailMessage" required></textarea>
                        </div>

                        <button class="sd-submit-btn" type="submit" [disabled]="isSubmitting">
                            {{ isSubmitting ? 'Sending...' : 'Submit' }}
                        </button>
                        @if (submissionMessage) {
                        <p role="status">{{ submissionMessage }}</p>
                        }
                    </form>
                </div>
            </div>
        </div>
    </section>

</div>